import {putMethod} from '~/api'

async function put(request, body) {
    return await putMethod(`/api/serviceComments/${request.productType}/${request.processId}`, body)
}

export {put}
